import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import Hero from "../components/hero/hero"
import About from "../components/about/about"
import Grid from "../components/grid/grid"
import Grid2 from "../components/grid/grid2"
import Contact from "../components/contact/contact"
import Map from "../components/map/map"
import Booking from "../components/booking/booking"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />

    <Hero />
    <Booking />
    <About />
    <h2 id="services" style={{ textAlign: "center" }}>
      Services
    </h2>
    <Grid />
    <Grid2 />
    <Contact />
    <Map />
  </Layout>
)

export default IndexPage
